<app-header [hasLogout]="false" (redirectToHomePage)="redirectToPortal()" />

<main class="p-4">
  <router-outlet />
</main>
